type IObj = {
  name: string;
};

export const refactorData = (obj: IObj) => {
  return {
    name: obj.name
  };
};
